import { Checkbox, Tooltip } from 'bold-ui'
import { Action } from 'graphql/types.generated'
import { ChangeEvent } from 'react'

import { disabledAction, validAction } from '../../reterritorializacao/utils/reterritorializacao'
import {
  CheckAllActionParams,
  InativacaoImoveisQueryResult,
  InativacaoImovelItemModel,
  MAXIMUM_INATIVACAO_IMOVEIS_SIZE,
} from '../model-inativacaoImoveis'
import { getPermissionInativarImovelAction } from '../utils/utils-inativacaoImoveis'

interface InativacaoImoveisCheckAllProps {
  checkedItems: Set<string>
  setCheckedItems: (items: Set<string>) => void
  pageResult: InativacaoImoveisQueryResult
  disabled?: boolean
}

export function InativacaoImoveisCheckAll({
  checkedItems,
  setCheckedItems,
  pageResult,
  disabled,
}: Readonly<InativacaoImoveisCheckAllProps>) {
  const validImoveisChecked: Array<InativacaoImovelItemModel> = []
  const validImoveisUnchecked: Array<InativacaoImovelItemModel> = []

  pageResult.content.forEach((imovelDto) => {
    const action = getPermissionInativarImovelAction(imovelDto)
    action.enabled && !checkedItems.has(imovelDto.id) && validImoveisUnchecked.push(imovelDto)
    action.enabled && checkedItems.has(imovelDto.id) && validImoveisChecked.push(imovelDto)
  })

  const handleCheck = (event: ChangeEvent<HTMLInputElement>) => {
    const newCheckedItems = new Set(checkedItems)
    if (event.target.checked)
      validImoveisUnchecked.forEach((imovel: InativacaoImovelItemModel) => newCheckedItems.add(imovel.id))
    else validImoveisChecked.forEach((imovel) => newCheckedItems.delete(imovel.id))
    setCheckedItems(newCheckedItems)
  }

  const checkAllChecked = validImoveisChecked.length > 0 && validImoveisUnchecked.length === 0
  const checkAllAction = getCheckAllAction({
    disabled,
    checkAllChecked,
    checkedItemsSize: checkedItems.size,
    validImoveisUncheckedSize: validImoveisUnchecked.length,
  })

  return (
    <Tooltip text={checkAllAction.hint ?? ''}>
      <div>
        <Checkbox onChange={handleCheck} checked={checkAllChecked} disabled={!checkAllAction.enabled} />
      </div>
    </Tooltip>
  )
}

const maxCheckedActionInativacao = (): Action => ({
  enabled: false,
  hint: `Seleção bloqueada. Por razões de segurança você pode inativar até ${MAXIMUM_INATIVACAO_IMOVEIS_SIZE} imóveis por vez.`,
})

const getCheckAllAction = ({
  disabled,
  checkAllChecked,
  checkedItemsSize,
  validImoveisUncheckedSize,
}: CheckAllActionParams): Action => {
  if (disabled) return disabledAction

  const exceedsMaximumCheckedItems =
    !checkAllChecked && checkedItemsSize + validImoveisUncheckedSize > MAXIMUM_INATIVACAO_IMOVEIS_SIZE

  if (exceedsMaximumCheckedItems) return maxCheckedActionInativacao()

  return validAction
}
